// extracted by mini-css-extract-plugin
export default {"container":"styles_container__bR-mL","qrcode":"styles_qrcode__dzG9w"};